import { Link, useHistory } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

import { Button } from '../../components-ui/Button';

export function RouteNotFound() {
  const history = useHistory();

  return (
    <main className="flex min-h-[80vh] w-full items-center justify-center">
      <div className="w-full max-w-2xl px-6 text-center md:px-12">
        <h1
          aria-label="404 — page not found"
          className="select-none text-[clamp(96px,18vw,224px)] font-medium leading-[0.9] tracking-[0.06em] text-neutral-900"
        >
          404
        </h1>

        <div className="mx-auto mt-8 h-px w-full bg-green-400" aria-hidden="true" />

        <h2 className="mt-10 text-3xl font-medium tracking-tight text-neutral-800 md:text-4xl">Page not found.</h2>

        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-neutral-500 md:text-lg">
          This page doesn't exist, or you don't have access to it from here.
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6">
          <Button asChild variant="success" size="lg">
            <Link to="/">Go to home</Link>
          </Button>
          <Button
            variant="link"
            onClick={() => history.goBack()}
            className="gap-2 px-0 text-green-400 hover:text-green-400/90"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Go back
          </Button>
        </div>
      </div>
    </main>
  );
}

export default RouteNotFound;
